/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { NbAccessChecker } from '@nebular/security';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private accessChecker: NbAccessChecker, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!route.data.accessControl) {
      return of(true);
    }
    return this.accessChecker
      .isGranted(
        route.data.accessControl.permission,
        route.data.accessControl.resource
      )
      .pipe(
        tap(
          (isAuthorized) => isAuthorized || this.router.navigate(['/pages/403'])
        )
      );
  }
}
